import { render, staticRenderFns } from "./platcontractfile-add-or-update.vue?vue&type=template&id=b1edf21a&"
import script from "./platcontractfile-add-or-update.vue?vue&type=script&lang=js&"
export * from "./platcontractfile-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports